/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Manual_Qc_Linked_EventsInputs */



/**
* | output |
* | --- |
* | "Will be linked to {count} selected event(s)" |
*
* @param {Manual_Qc_Linked_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_linked_events = /** @type {((inputs: Manual_Qc_Linked_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Linked_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sera lie a ${i?.count} evenement(s) selectionne(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Wird mit dem/den ausgewählten Ereignis(sen) ${i?.count} verknüpft`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sarà collegato a ${i?.count} eventi selezionati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Будет связано с выбранным(и) событием(ями) ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se vinculará a ${i?.count} eventos seleccionados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将与 ${i?.count} 选定的事件关联`)
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントにリンクされます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) से लिंक किया जाएगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Será vinculado ao(s) evento(s) selecionado(s) ${i?.count}`)
	return /** @type {LocalizedString} */ (`Will be linked to ${i?.count} selected event(s)`)
});